// 将base64转换成file
export const dataURLToFile = (dataUrl) => {
  try {
    let _this = this,
      bstr = null,
      n = null,
      u8arr = null;
      let mime = dataUrl.split(",")[0].match(/:(.*?);/)[1] //mime类型 image/png
    if (dataUrl.indexOf(",") > 0) {
      //  ios兼容
      let arr = dataUrl.split(",");
      bstr = atob(arr[1]);
    } else {
      bstr = atob(dataUrl);
    }
    n = bstr.length;
    u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    let file = new File([u8arr], `select_oil_${new Date().getTime()}.${mime.split("/")[1]}`, { type: mime })
    _this
      .lrz(file, {
        quality: 0.4,
      })
      .then((rst) => {
        let base = rst.base64.split("base64,");
        _this.uploadVinImage(base[1]);
      });
  } catch (err) {
    console.error("异常", err);
  }
};
/**
 * 拼接对象为请求字符串
 * @param {Object} obj - 待拼接的对象
 * @returns {string} - 拼接成的请求字符串
 */
export const encodeSearchParams = (obj) => {
  const params = [];
  Object.keys(obj).forEach((key) => {
    let value = obj[key];
    // 如果值为undefined我们将其置空
    if (typeof value === "undefined") {
      value = "";
    }
    // 对于需要编码的文本（比如说中文）我们要进行编码
    params.push([key, encodeURIComponent(value)].join("="));
  });
  return params.join("&");
};
/**
 * 压缩图片方法
 * @param {file} file 文件
 * @param {Number} quality 图片质量(取值0-1之间默认0.92)
 */
export const compressImg = (file, quality) => {
  var qualitys = 0.52;
  console.log(parseInt((file.size / 1024).toFixed(2)));
  if (parseInt((file.size / 1024).toFixed(2)) < 1024) {
    qualitys = 0.85;
  }
  if (5 * 1024 < parseInt((file.size / 1024).toFixed(2))) {
    qualitys = 0.92;
  }
  if (quality) {
    qualitys = quality;
  }
  if (file[0]) {
    return Promise.all(
      Array.from(file).map((e) => this.compressImg(e, qualitys))
    ); // 如果是 file 数组返回 Promise 数组
  } else {
    return new Promise((resolve) => {
      console.log(file);
      if ((file.size / 1024).toFixed(2) < 300) {
        resolve({
          file: file,
        });
      } else {
        const reader = new FileReader(); // 创建 FileReader
        reader.onload = ({ target: { result: src } }) => {
          const image = new Image(); // 创建 img 元素
          image.onload = async () => {
            const canvas = document.createElement("canvas"); // 创建 canvas 元素
            const context = canvas.getContext("2d");
            var targetWidth = image.width;
            var targetHeight = image.height;
            var originWidth = image.width;
            var originHeight = image.height;
            if (
              1 * 1024 <= parseInt((file.size / 1024).toFixed(2)) &&
              parseInt((file.size / 1024).toFixed(2)) <= 10 * 1024
            ) {
              var maxWidth = 1600;
              var maxHeight = 1600;
              targetWidth = originWidth;
              targetHeight = originHeight;
              // 图片尺寸超过的限制
              if (originWidth > maxWidth || originHeight > maxHeight) {
                if (originWidth / originHeight > maxWidth / maxHeight) {
                  // 更宽，按照宽度限定尺寸
                  targetWidth = maxWidth;
                  targetHeight = Math.round(
                    maxWidth * (originHeight / originWidth)
                  );
                } else {
                  targetHeight = maxHeight;
                  targetWidth = Math.round(
                    maxHeight * (originWidth / originHeight)
                  );
                }
              }
            }
            if (
              10 * 1024 <= parseInt((file.size / 1024).toFixed(2)) &&
              parseInt((file.size / 1024).toFixed(2)) <= 20 * 1024
            ) {
              maxWidth = 1400;
              maxHeight = 1400;
              targetWidth = originWidth;
              targetHeight = originHeight;
              // 图片尺寸超过的限制
              if (originWidth > maxWidth || originHeight > maxHeight) {
                if (originWidth / originHeight > maxWidth / maxHeight) {
                  // 更宽，按照宽度限定尺寸
                  targetWidth = maxWidth;
                  targetHeight = Math.round(
                    maxWidth * (originHeight / originWidth)
                  );
                } else {
                  targetHeight = maxHeight;
                  targetWidth = Math.round(
                    maxHeight * (originWidth / originHeight)
                  );
                }
              }
            }
            canvas.width = targetWidth;
            canvas.height = targetHeight;
            context.clearRect(0, 0, targetWidth, targetHeight);
            context.drawImage(image, 0, 0, targetWidth, targetHeight); // 绘制 canvas
            const canvasURL = canvas.toDataURL("image/jpeg", qualitys);
            const buffer = atob(canvasURL.split(",")[1]);
            let length = buffer.length;
            const bufferArray = new Uint8Array(new ArrayBuffer(length));
            while (length--) {
              bufferArray[length] = buffer.charCodeAt(length);
            }
            const miniFile = new File([bufferArray], file.name, {
              type: "image/jpeg",
            });
            console.log({
              file: miniFile,
              origin: file,
              beforeSrc: src,
              afterSrc: canvasURL,
              beforeKB: Number((file.size / 1024).toFixed(2)),
              afterKB: Number((miniFile.size / 1024).toFixed(2)),
              qualitys: qualitys,
            });
            resolve({
              file: miniFile,
              origin: file,
              beforeSrc: src,
              afterSrc: canvasURL,
              beforeKB: Number((file.size / 1024).toFixed(2)),
              afterKB: Number((miniFile.size / 1024).toFixed(2)),
            });
          };
          image.src = src;
        };
        reader.readAsDataURL(file);
      }
    });
  }
};
